import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setLogin } from "./UserActions";
import { message } from "antd";
import { store } from "..";
import { updateAuthorCollections } from "./PublicPageDataSlice";


interface PublicCollectionsDataState {
  collections: any;
  pagination: any;
  items: any;
  loader: any;
  searchValue: string | null;
  sortBy: string | null;
  page: any;
  collectionsLoader: any;
  perpage: any;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error:  any;
  likedCollections:any,
  dislikedCollections:any,
  userBookmarks:any,
  lastBookmark:any,
  modalResponse:any,
  publicItemsLoader:any,
  publicItemsError:any,
}

const initialState: PublicCollectionsDataState = {
  collections: null,
  pagination: null,
  items: null,
  loader: false,
  collectionsLoader: true,
  searchValue: null,
  sortBy: null,
  page: 1,
  perpage: 10,
  status: 'idle',
  error: null,
  likedCollections: null,
  dislikedCollections: null,
  userBookmarks: {},
  lastBookmark: {},
  modalResponse: false,
  publicItemsLoader:false,
  publicItemsError: false,
};

function updateKeyById(array: any, id: any, keyToUpdate: any, payload: any) {
  return array?.map((obj: any) => {
    if (obj.id === id) {
      // Create a new object with the updated key
      return {
        ...obj,
        [keyToUpdate]: obj[keyToUpdate] + parseInt(payload)
      };
    }
    // For other objects, return them unchanged
    return obj;
  });
}


export const updateVotes = (value:any)=> async (dispatch: any, getState:any) => {
  const { id, payload } = value; 
  const state :any =getState();

  console.log("HEY IT IS IN FUNCS")

  if(window.location.pathname === '/collections/' || window.location.pathname === '/public-collections-list' ){
  const {collections} = state.publicCollectionsData;
    let updated = updateKeyById(collections, id, 'votes', payload);
    dispatch(updatePublicCollections(updated))
    console.log(updated, 'PUBLIC COLELCIT LIST')
  }

  else if(window.location.pathname.includes('/author') ){
    const {authorCollections} = state.publicPageData;
    let updated = updateKeyById(authorCollections, id, 'votes', payload);
    console.log(updated, 'HAS TO SET')
    dispatch(updateAuthorCollections({data: updated, apiCall :  false}))
  }

  else if (window.location.pathname.includes('collection')){

    const {items} = state.publicCollectionsData;
    let updated = {
      ...items,
      details : {
        ...items.details,
        details : {
          ...items.details.details ,
          votes : items.details.details.votes + payload
        }
      }
    }
    dispatch(updatePublicItems(updated))

    console.log('UPDATED VOTES', updated)

  }
}


// Fetching User - Bookmark & Favourites

export const fetchUserBookmarks: any = createAsyncThunk(
  "interactions/fetchUserBookmarks",
  async (_, { getState, dispatch, rejectWithValue }) => {

    console.log()
    try {
      var myHeaders = new Headers();
      myHeaders.append("authorization", (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`);

      var requestOptions:any = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        credentials: 'omit',
      };

      const response = await fetch(
        "https://www.notablehq.com/wp-json/nhq/v1/me/get?fields=saved_collections",
        requestOptions
      );

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error);
      }

      const result = await response.json();
      return result;

    } catch (error) {
      console.error('Error fetching user bookmarks:', error);
      throw error;
    }
  }
);

// Fetching User Interactions - Liked Disliked Collections

export const fetchUserInteractions: any = createAsyncThunk(
  "interactions/fetchUserInteractions",
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("authorization", (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`);

      var requestOptions:any = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        credentials: 'omit',
      };

      const response = await fetch(
        "https://www.notablehq.com/wp-json/nhq/v1/me/get?fields=likes,dislikes",
        requestOptions
      );

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error);
      }

      const result = await response.json();
      return result;

    } catch (error) {
      console.error('Error fetching user interactions:', error);
      throw error;
    }
  }
);

// Public Collections Data Fetch

export const fetchPublicCollections: any = createAsyncThunk(
  "collections/fetchPublicCollections",
  async ({page, search, sortBy, perPage, aiSearch}: any, { getState, rejectWithValue, dispatch }) => {
    const requestOptions: RequestInit = {
      method: "GET",
      redirect: "follow",
      credentials: 'omit',
    };
    
    const NHQ = (window as any)?.NHQ;
    let current_id, page_type, token;

    if (NHQ) {
      ({ current_id, page_type, token } = NHQ);
    }
    
    let state:any = getState();
    let { likedCollections, dislikedCollections} = state.publicCollectionsData;

    const queryParams = new URLSearchParams();
    if (page) queryParams.append('page', page);
    if (perPage) queryParams.append('per_page', perPage);
    if (search) queryParams.append('search', search);
    if (sortBy) queryParams.append('sortby', sortBy);
    if (aiSearch) queryParams.append('ai', 'true');
    if(page_type === 'tag'){queryParams.append('tags', current_id)} else if(page_type === 'category') {queryParams.append('categories', current_id)}



    let apiUrl: any = `https://www.notablehq.com/wp-json/nhq/v1/collections/list?${queryParams}`;


    const response = await fetch(
      apiUrl,
      requestOptions
      );

      if ((typeof token !== "undefined" && token !== '' && token !== null && likedCollections === null) || process.env.REACT_APP_AUTH_TOKEN) {
        // dispatch(setLogin(true));
        // console.log('login setted true')
        dispatch(fetchUserBookmarks());
        dispatch(fetchUserInteractions());
      }
      else {
        // dispatch(setLogin(false))
        // console.log('login setted false')
      }
      
       if (!response.ok) {
        const error = await response.json();
         return rejectWithValue(error)
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
    const result = await response.json();
    return result;  

  }
);

// Public Items Data Fetch

export const fetchPublicItems: any = createAsyncThunk(
  "items/fetchPublicItems",
  async (id: any, { getState, rejectWithValue, dispatch }) => {

    const state: any = getState();
    const { isLogin } = state.userActions;
    console.log(isLogin, 'STATE')

    const headers: any = {
      "Content-Type": "application/json",
    }

    if (isLogin) {
      headers['Authorization'] = (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`;
    }

    const requestOptions: RequestInit = {
      method: "GET",
      redirect: "follow",
      credentials: 'omit',
      headers: headers
    };


    const response = await fetch(
      `https://www.notablehq.com/wp-json/nhq/v1/collections/${id}/?fields=all&request_for=${window.location.href}`,
      requestOptions
    );

    // if ((typeof (window as any).NHQ?.token !== "undefined" && (window as any).NHQ?.token !== '' && (window as any).NHQ?.token !== null && likedCollections === null || process.env.REACT_APP_AUTH_TOKEN) ) {
    if ((typeof (window as any).NHQ?.token !== "undefined" && (window as any).NHQ?.token !== '' && (window as any).NHQ?.token !== null ) || process.env.REACT_APP_AUTH_TOKEN) {
      dispatch(setLogin(true));
      dispatch(fetchUserBookmarks());
      dispatch(fetchUserInteractions());
    }
    else {
      dispatch(setLogin(false))
    }

    if (!response.ok) {
      throw new Error(`Error - ${response.status}`);
      
    }

    const result = await response.json();
    return result;
  }
);

const publicCollectionsDataSlice:any = createSlice({
  name: "publicCollectionsData",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.searchValue = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPerPage: (state, action) => {
      state.perpage = action.payload;
    },
    removeBookmarkLocal: (state, action) => {
      delete state.userBookmarks[action.payload];
    },
    updateBookmarkLocal: (state, action) => {
      const id = action.payload?.id;
      const value = action.payload?.checkedValues
      state.userBookmarks[id] = value;
    },
    setUserBookmarks :(state, action) =>{
      state.userBookmarks = action.payload
    },
    setLastBookmark : (state, action) =>{
      state.lastBookmark = action.payload
    },
    addLike: (state, action) => {
      state.likedCollections = [...state.likedCollections, action.payload]
      const newArray = state.dislikedCollections.filter((item:any) => item !== action.payload);
      state.dislikedCollections = newArray;
    },
    addDislike: (state, action) =>{
      state.dislikedCollections = [...state.dislikedCollections, action.payload]
      const newArray2 = state.likedCollections.filter((item:any) => item !== action.payload);
      state.likedCollections = newArray2;
    },
    removeLike: (state, action) =>{
      const newArray3 = state.likedCollections.filter((item:any) => item!== action.payload);
      state.likedCollections = newArray3
    },
    removeDislike: (state, action) =>{
      const newArray4 = state.dislikedCollections.filter((item:any) => item!== action.payload);
      state.dislikedCollections = newArray4
    },
    setPublicItemsError: (state, action) =>{
      state.publicItemsError = action.payload
    },
    updatePublicCollections : (state,action)=>{
      state.collections = action.payload;
    },
    updatePublicItems : (state,action)=>{
      state.items = action.payload;
    },
    
    refreshCard: (state, action) =>{

      if(window.location.pathname === '/collections/' || window.location.pathname === '/public-collections-list'){
      state.collections = state.collections?.map((collection:any) => {
        const isLiked = state.likedCollections?.includes(collection.id);
        const isDisliked = state.dislikedCollections?.includes(collection.id);

        console.log("refresh card run")

        return {
          ...collection,
          liked: isLiked,
          disliked: isDisliked,
          // votes: collection.details.likes - collection.details.dislikes,
        };
      });

      (state.collections !== null && state.userBookmarks !== null) && 
      (state.collections = state.collections?.map((collection:any) => {
        let isBookmarked;
        state.userBookmarks.hasOwnProperty(collection.id) ?  isBookmarked = state.userBookmarks[collection.id] :  isBookmarked = false

        return {
          ...collection,
          bookmarked: isBookmarked,
        };
      }));

    }

      // *******************************************************

      else if (window.location.pathname.includes('collection')){

      const isLiked = state.likedCollections?.includes(state.items?.id);
      const isDisliked = state.dislikedCollections?.includes(state.items?.id);
    
      // Calculate isBookmarked
      let isBookmarked = false;
      if (state.items !== null && state.userBookmarks !== null) {
        isBookmarked = state.userBookmarks.hasOwnProperty(state.items?.id) ? state.userBookmarks[state.items?.id] : false;
      }
      
      // Create a new copy of state.items.details with updated values
      const updatedDetails = {
        ...state?.items?.details,
        details: {
          ...state?.items?.details?.details,
          liked: isLiked,
          disliked: isDisliked,
          bookmarked: isBookmarked,
        },
      };
      
      console.log(isLiked, state.likedCollections, 'updated DETails')
    
      // Return a new state object with updated items details
      return {
        ...state,
        items: {
          ...state.items,
          details: updatedDetails,
        },
      };
    } 


    },
    
    
  //   updateVotes: (state, action) => {
  //     const { id, payload } = action.payload; 


  //     if(window.location.pathname === '/collections/' || window.location.pathname === '/public-collections-list' ){
  //       state.collections = updateKeyById(state.collections, id, 'votes', payload);
  //     }
  //     else if (window.location.pathname.includes('collection')){
        
  // const updatedDetails = {
  //   ...state.items.details,
  //   details: {
  //     ...state.items.details.details,
  //     votes: state.items.details.details.votes + parseInt(payload), // Update votes using payload
  //   },
  // };

  // // Return a new state object with updated items details
  // return {
  //   ...state,
  //   items: {
  //     ...state.items,
  //     details: updatedDetails,
  //   },
  // };
  //     }




    
  //   },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicCollections.pending, (state) => {
        state.status = 'loading';
        state.collectionsLoader = true;
      })
      .addCase(fetchPublicCollections.fulfilled, (state, action) => {
        // state.status = 'succeeded';
        state.collections = action.payload.collections;
        state.pagination = action.payload.pagination;
        state.collectionsLoader = false;
        
        if (state.collections !== null) {
          state.collections = state.collections?.map((collection: any) => {
            return {
              ...collection,
              votes: collection.details.likes - collection.details.dislikes,
            };
          });
        }
        
        (state.collections !== null && state.likedCollections !== null) &&
        (state.collections = state.collections?.map((collection:any) => {
          const isLiked = state.likedCollections?.includes(collection.id);
          const isDisliked = state.dislikedCollections?.includes(collection.id);

          return {
            ...collection,
            liked: isLiked,
            disliked: isDisliked,
            votes: collection.details.likes - collection.details.dislikes,
          };
        }));
        
        (state.collections !== null && state.userBookmarks !== null) && 
      (state.collections = state.collections?.map((collection:any) => {
        let isBookmarked;
        state.userBookmarks.hasOwnProperty(collection.id) ?  isBookmarked = state.userBookmarks[collection.id] :  isBookmarked = false

        return {
          ...collection,
          bookmarked: isBookmarked,
        };
      }));

      })
      .addCase(fetchPublicItems.fulfilled, (state, action) => {
        // state.status = 'succeeded';
        state.items = action.payload;
        state.publicItemsLoader = false;
        state.publicItemsError = false;
        state.modalResponse = true;
        console.log("Fetch Public Items")

        const isLiked = state.likedCollections?.includes(state.items?.id);
        const isDisliked = state.dislikedCollections?.includes(state.items?.id);
        const votes = state?.items?.details?.details?.likes - state?.items?.details?.details?.dislikes;

        if(state.items?.details){
          state.items.details.details.liked = isLiked;
          state.items.details.details.disliked = isDisliked;
          state.items.details.details.votes = votes;
          }

        
        // votes: collection.details.likes - collection.details.dislikes,

      if(state.items !== null && state.userBookmarks !== null) {

        let isBookmarked;
        state.userBookmarks.hasOwnProperty(state.items?.id) ?  isBookmarked = state.userBookmarks[state.items?.id] :  isBookmarked = false
        
      if(state?.items.details?.details?.bookmarked){
        state.items.details.details.bookmarked  = isBookmarked;
      }

      console.log(isBookmarked, 'IS BOOKMARKED')
      }
        
      })
      .addCase(fetchPublicItems.pending, (state, action) => {
        state.publicItemsLoader = true;
        state.publicItemsError = false;
      })
      .addCase(fetchPublicItems.rejected, (state, action) => {
        state.publicItemsLoader = false;
        state.publicItemsError = true;
        state.modalResponse = false;
        message.error("Something went wrong. Try again later.", 1);
      })
    .addCase(fetchPublicCollections.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.payload;

    })
    .addCase(fetchUserInteractions.pending, (state) => {
      // Set loading state if needed
    })
    .addCase(fetchUserInteractions.fulfilled, (state, action) => {
      state.likedCollections = action.payload.likes?.map((like:any)=>parseInt(like));
      state.dislikedCollections = action.payload.dislikes?.map((dislike:any)=>parseInt(dislike));
      
      console.log("fetchh user interaction")

      const isLiked = state.likedCollections?.includes(state.items?.id);
      const isDisliked = state.dislikedCollections?.includes(state.items?.id);
      const votes = state?.items?.details?.details?.likes - state?.items?.details?.details?.dislikes;

      if(state.items){
        state.items.details.details.liked = isLiked;
        state.items.details.details.disliked = isDisliked;
        // state.items.details.details.votes = votes;
        }

      
      // votes: collection.details.likes - collection.details.dislikes,


    if(state.items !== null && state.userBookmarks !== null) {

      let isBookmarked;
      state.userBookmarks.hasOwnProperty(state.items?.id) ?  isBookmarked = state.userBookmarks[state.items?.id] :  isBookmarked = false
      
        state.items.details.details = {
          ...state.items.details.details,
          bookmarked : isBookmarked
        }
      
    }

    // *****************************************************************************************

      (state.collections !== null) &&
      (state.collections = state.collections?.map((collection:any) => {
        const isLiked = state.likedCollections?.includes(collection.id);
        const isDisliked = state.dislikedCollections?.includes(collection.id);

        return {
          ...collection,
          liked: isLiked,
          disliked: isDisliked,
          // votes: collection.details.likes - collection.details.dislikes,
        };
      }));
    })
    .addCase(fetchUserInteractions.rejected, (state, action) => {
      // Handle error state if needed
    })
    .addCase(fetchUserBookmarks.pending, (state) => {
      // Set loading state if needed
    })
    .addCase(fetchUserBookmarks.fulfilled, (state, action) => {
        state.userBookmarks = action.payload.saved_collections;
        state.lastBookmark = action.payload.saved_collections;

        console.log("fetchuserbookmarks")

    if(state.items !== null && state.userBookmarks !== null) {

      let isBookmarked;
      state.userBookmarks.hasOwnProperty(state.items?.id) ?  isBookmarked = state.userBookmarks[state.items?.id] :  isBookmarked = false

        state.items.details.details = {
            ...state.items.details.details,
            bookmarked : isBookmarked
        }
    }



        // ***************************************************************

        (state.collections !== null && state.userBookmarks !== null) &&
      (state.collections = state.collections?.map((collection:any) => {
        let isBookmarked;
        state.userBookmarks.hasOwnProperty(collection.id) ?  isBookmarked = state.userBookmarks[collection.id] :  isBookmarked = false

        return {
          ...collection,
          bookmarked: isBookmarked,
        };
      }));
      
    })
    .addCase(fetchUserBookmarks.rejected, (state, action) => {
      // Handle error state if needed
    });
  },
});

export default publicCollectionsDataSlice.reducer;
export const {setSearch, setPublicItemsError,  setPage, setSortBy, setPerPage, addLike, removeLike, addDislike, removeDislike, refreshCard, removeBookmarkLocal,updatePublicCollections,updatePublicItems, updateBookmarkLocal, setLastBookmark, setUserBookmarks } = publicCollectionsDataSlice.actions;
